// src/api/notification/parentNotificationQueries.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import {
  createParentNotification,
  getAllParentNotifications,
  deleteAllParentNotifications,
  markParentNotificationAsRead,
  deleteParentNotification,
} from './parentNotificationApi';

// Create a new parent notification
export const useCreateParentNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createParentNotification,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['parentNotifications'] });
      toast.success('Notification created successfully');
    },
    onError: (error) => {
      console.error('Error creating parent notification:', error);
      toast.error(
        error.response?.data?.message || 'Failed to create notification'
      );
    },
  });
};

// Get all parent notifications
export const useGetAllParentNotifications = () => {
  return useQuery({
    queryKey: ['parentNotifications'],
    queryFn: getAllParentNotifications,
    initialData: { data: [] },
  });
};

// Delete all parent notifications
export const useDeleteAllParentNotifications = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAllParentNotifications,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parentNotifications'] });
      toast.success('All notifications deleted successfully');
    },
    onError: (error) => {
      console.error('Error deleting all parent notifications:', error);
      toast.error(
        error.response?.data?.message || 'Failed to delete notifications'
      );
    },
  });
};

// Get a single parent notification by ID
export const useReadParentNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['Mark-parentNotification'],
    mutationFn: markParentNotificationAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['parentNotifications'] });
    },
  });
};

// Delete a parent notification by ID
export const useDeleteParentNotification = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteParentNotification,
    onSuccess: (data, notifId) => {
      queryClient.invalidateQueries({ queryKey: ['parentNotifications'] });
      toast.success('Notification deleted successfully');
    },
    onError: (error) => {
      console.error('Error deleting parent notification:', error);
      toast.error(
        error.response?.data?.message || 'Failed to delete notification'
      );
    },
  });
};
